/* eslint-disable unicorn/prefer-module */
import React from "react";
import { EdificiosTable } from "../../components";

export const Edificios = () => (
  <div>
    <EdificiosTable />
  </div>
);
